export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-1440w.8461583f.webp";